export const locales = [
  require('apexcharts/dist/locales/es.json'),
  require('apexcharts/dist/locales/en.json'),
  require('apexcharts/dist/locales/fr.json'),
  {
    name: 'gl',
    options: {
      toolbar: {
        exportToSVG: 'Descargar SVG',
        exportToPNG: 'Descargar PNG',
      }
    }
  }
]
